import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import atlasApi from "../utils/atlasapi";
import schemas from "../data/dataSchemas";



class DialogDisassociateProperty extends React.Component {

	

	constructor(props) {
		super(props);
		
		this.state = {
			validated: false,
			status: {sent:null, message:''}
		}
		
		//this.owner = schemas.owner.cast(this.props.owner);
		
	}
	updateStatus(s){
		var x = {...this.state};
		x.status = s;
		this.setState(x);
		this.forceUpdate();
	}


	handleClose(data){
		this.props.onClose(data);
		;
		setTimeout(()=>{
			this.updateStatus({sent:null, message:''})
		}, 500);
	};

	handleSubmit(){

		
		this.updateStatus({sent:false, success:false, message:'Detach owner...'});
		//saveguard for testing
	
		//console.log(setMainScenario);
		atlasApi.disassociateProperty(this.props.setup.owner.id, this.props.setup.property).then((response)=>{
			if(response.updateSuccess){
				this.updateStatus({sent:true, success:true, message:'The owner is detached'});
				
				if(response.updateSuccess){
					
					if(this.props.onDelete)
						this.props.onDelete( this.props.setup.property, this.props.setup.owner.id);
					
					if(this.props.setup.onDelete)
						this.props.setup.onDelete( this.props.setup.property, this.props.setup.owner);
					
				}
				
				
				setTimeout(()=>this.handleClose(), 2000);
				
			}
			else
				this.updateStatus({sent:true, success:false, message:'Error detaching owner'});
			
			
			
		}).catch((e)=>{
			this.updateStatus({sent:true, success:false, message:'Error detaching owner'});
		});
		//this.updateStatus({sent:false, success:false, message:'Saving...'});
		
	};

	handleOnShow(e){
//		if(this.props.setup.prompt)
//			return false;
//		else
//			this.handleSubmit();
		
	};

	render() {
		if(!this.props.setup.owner)
			return;
		
		return (
			<Modal show={this.props.setup.open} onHide={(e)=>this.handleClose(e)} onShow={(e)=>this.handleOnShow(e)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Detach owner?</Modal.Title>
				</Modal.Header>

				{this.state.status.sent === null ? (
					<React.Fragment>
						<Modal.Body>
							<Row className="">
								<Col xs="12" className="dialog-feedback-icon text-center">
									<i className="ri-error-warning-line text-warning" />
								</Col>
								<Col xs="12" className="dialog-feedback-text mb-1">
								Are you sure you want to detach <b>“{this.props.setup.owner.fullName}”</b> from property <b>“{this.props.setup.property}”</b>?
								</Col>
								<Col xs="12" className="dialog-feedback-text sm mb-2">
									This action can be undone at any time. The owner and the property will not be deleted.
								</Col>
							</Row>
						</Modal.Body>
						<Modal.Footer>
							<Button className="me-auto" variant="secondary" onClick={()=>{this.handleClose()}}>Close</Button>
							<Button onClick={()=>{this.handleSubmit()}} variant="success">Yes</Button>
						</Modal.Footer>
					</React.Fragment>
				) : (
				<Modal.Body>
					<Row className="mb-3 dialog-feedback">
						<Col xs="12" className="dialog-feedback-icon text-center">
							{
							this.state.status.sent ?
								(this.state.status.success ? 
									(<i className="ri-checkbox-circle-line text-success"></i>)
									:
									(<i className="ri-error-warning-line text-warning"></i>)
								)
								:
								(<Spinner animation="border" variant="info" className="mt-5" />)
							}
						</Col>
						<Col xs="12" className="dialog-feedback-text mb-5">
							{this.state.status.message}
						</Col>
					</Row>
				</Modal.Body>	
				)}

			</Modal>
		);
	}
}

export default DialogDisassociateProperty;